'use strict';

/* Modules */
import asset from './components/asset';

/* Module */
export default angular.module('conduu.sm', [asset])
  .name;



// WEBPACK FOOTER //
// ./client/~sm/index.js